<div class="cards-container">
    <ng-container *ngFor="let specialOffer of specialOffers">
        <div class="card special-offer-card overflow-hidden"
            [ngClass]="{'cursor-pointer': specialOffer.status !== SPECIAL_OFFER_STATUS.UPCOMING}"
            (click)="navigateToDetailHandler(specialOffer)">
            <div class="position-relative image-container">
                <img
                    [src]="path+'/getStoredFile?fileName='+specialOffer.campaignImageStoragePath+'&access_token='+accesToken+'&appId='+appId"
                    alt="Campaign image"
                    class="card-img-top img-fluid object-fit-cover"/>
                <div class="position-absolute top-0 end-0 status-box"
                    *ngIf="specialOffer.status!==SPECIAL_OFFER_STATUS.ONGOING">
                    <div HJSuppress class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                        {{"specialOffers.statusMessage."+specialOffer.status.toLowerCase() | translate}}
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div HJSuppress class="manufacturer-details fw-semibold text-secondary text-start mb-2">{{specialOffer.manufacturerName}}</div>
                    <div HJSuppress class="asset-detail fw-semibold text-start mb-2">{{specialOffer.assetName}}</div>
                <div class="d-flex flex-wrap gap-2 mb-3 info-box">
                    <span HJSuppress class="status-badge info">{{specialOffer.campaignType}}</span>
                    <span HJSuppress class="status-badge info">{{specialOffer.dealerName}}</span>
                    <span HJSuppress class="status-badge info">
                        {{'specialOffers.specialOfferClientList.installment' | translate}}
                        {{specialOffer.estMonthlyInstallment}}
                    </span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <span HJSuppress class="fs-5 fw-bold text-primary">
                        {{specialOffer.assetPrice}}
                        {{specialOffer.currencyCode}}
                    </span>
                    <div *ngIf="!specialOffer.hasRequestedOffer && specialOffer.status !== SPECIAL_OFFER_STATUS.UPCOMING">
                        <span class="text-secondary valability-detail">{{'specialOffers.specialOfferClientList.expires' | translate}}: </span>
                        <span HJSuppress class="text-danger fw-semibold">{{specialOffer.countdown$ | async}}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
